module.exports = __webpack_public_path__ + "assets/img/LJ-Hooker-eBook.51221f23.jpg";